export class DistPage {
    public app: string;
    public iosTitle: string;
    public androidTitle: string;
    public urlIosProd: string;
    public urlIosProdTitle: string;

    public urlIosTest: string;
    public urlIosTestTitle: string;

    public urlAndroidProd: string;
    public urlAndroidProdTitle: string;

    public urlAndroidTest: string;
    public urlAndroidTestTitle: string;
    constructor() {}
}
